<template>
  <div>
    <v-form
      ref="form"
      v-model="valid"
      :lazy-validation="true"
    >
      <v-data-table
        :headers="[
            { text: 'Välj', value: 'selected', sortable: false },
            { text: 'Kod', value: 'id', sortable: false },
            { text: 'Teoripaket', value: 'name', sortable: false },
            { text: 'Pris', value: 'price', sortable: false, width: '100' },
          ]"
        :items="items"
        :hide-default-footer="true"
      >
        <template
          slot="item.selected"
          slot-scope="props"
        >
          <v-checkbox
            :disabled="
                (selectedApplication &&
                  selectedApplication.professionId &&
                  selectedApplication.professionId === 848 &&
                  props.item.id === 'INTRO')
                "
            v-model="props.item.selected"
          >
          </v-checkbox>
        </template>
        <template slot="item.name" slot-scope="props">
          <div class="mb-2">{{props.item.name}}</div>
          <div class="caption mb-2" v-if="props.item.children && props.item.children.length">{{getChildrenText(props.item.children)}}</div>
        </template>
        <template
          slot="item.price"
          slot-scope="props"
        >
          <div>{{ props.item.price | currency | withCurrencyCode }}</div>
        </template>
      </v-data-table>
    </v-form>

    <MessageBox
      class="ma-2"
      v-if="selectedApplication && selectedApplication.professionId && selectedApplication.professionId === 848"
    >
      <h6>Ställningsbyggare - STIB</h6>
      <p>
        Vid beställning av komplett utbildningspaket, inriktning och fördjupning, är totalpriset 10 600kr. Vid
        beställning av utbildningspaket, inriktning, är totalpriset 5 400kr. Dessa priser på utbildningspaket sätts
        automatiskt av systemet vid beställning.
      </p>
    </MessageBox>
  </div>
</template>

<script>
import MessageBox from '@/components/common/MessageBox.vue'
import {mapGetters} from 'vuex'

export default {
  name: 'ApplicationDistanceEducationEdit',

  props: {
    items: {
      type: Array,
      required: true
    }
  },

  components: {
    MessageBox
  },

  data: () => ({
    valid: false
  }),

  created() {
    if (this.$refs.form) {
      this.$refs.form.reset()
    }
  },

  watch: {
    items: {
      handler(values) {
        this.$emit('checked', values)
      },
      immediate: true,
      deep: true
    }
  },

  computed: {
    ...mapGetters('application', [
      'selectedApplication',
      'applicationProfession',
      'applicationOrders',
      'applicationDistanceEductions',
      'applicationWorkplace',
      'canBeEdited'
    ]),

    ...mapGetters('basic', ['getStateByStatename', 'approvedByByn']),
    ...mapGetters('currentuser', ['currentUser', 'currentUserRole']),
    ...mapGetters('basic', ['orderedState'])
  },

  methods: {
    getChildrenText(children){
      return children.map(a => a.name).join(', ')
    },
    cancel() {
      console.log('App distance edu cancel click')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>